import Viktor from './Viktor';

/**
 * ViktorClient singleton
 *
 * Singleton pattern is a design pattern that allows us to use a single instance of a class everywhere.
 *
 */
const ViktorClient = (() => {
  /**
   * The Viktor instance
   * @var {Viktor} instance
   */
  let instance;

  /**
   * Create Viktor instance
   *
   * @returns {Viktor} The new Viktor instance
   */
  function createInstance() {
    instance = new Viktor().axiosInstance;
    return instance;
  }

  return () => {
    // Check if instance already exists
    return instance || createInstance();
  };
})();

export default ViktorClient;
